var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9297 1.6875H9.07031C4.9929 1.6875 1.6875 4.9929 1.6875 9.07031V17.9297C1.6875 22.0071 4.9929 25.3125 9.07031 25.3125H17.9297C22.0071 25.3125 25.3125 22.0071 25.3125 17.9297V9.07031C25.3125 4.9929 22.0071 1.6875 17.9297 1.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 17.0152C15.4411 17.0152 17.0152 15.4411 17.0152 13.4995C17.0152 11.5579 15.4411 9.98389 13.4995 9.98389C11.5579 9.98389 9.98389 11.5579 9.98389 13.4995C9.98389 15.4411 11.5579 17.0152 13.4995 17.0152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4552 15.258L7.41102 9.98535C6.79377 11.0541 6.46879 12.2666 6.46875 13.5008C6.46871 14.7349 6.7936 15.9474 7.41078 17.0161C8.02795 18.085 8.91565 18.9725 9.98459 19.5894C11.0536 20.2062 12.2661 20.5309 13.5002 20.5306L16.5444 15.258V15.257C16.2361 15.7917 15.7924 16.2358 15.258 16.5446C14.7236 16.8533 14.1172 17.0159 13.5 17.016C12.8828 17.0161 12.2765 16.8537 11.742 16.5451C11.2075 16.2364 10.7636 15.7925 10.4552 15.258Z",
    fill: "url(#paint0_linear_957_1273)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5439 15.2573L13.4998 20.5299C14.734 20.5301 15.9465 20.2054 17.0154 19.5883C18.0842 18.9712 18.9718 18.0837 19.5888 17.0147C20.2058 15.9458 20.5306 14.7333 20.5303 13.4991C20.5301 12.265 20.205 11.0526 19.5876 9.98389H13.4993L13.4985 9.98435C14.1157 9.98405 14.7222 10.1463 15.2568 10.4547C15.7914 10.7631 16.2353 11.2069 16.5441 11.7414C16.8528 12.2758 17.0153 12.8822 17.0153 13.4994C17.0153 14.1166 16.8527 14.7229 16.5439 15.2573Z",
    fill: "url(#paint1_linear_957_1273)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.2832C15.0371 16.2832 16.2832 15.0372 16.2832 13.5C16.2832 11.9629 15.0371 10.7168 13.5 10.7168C11.9629 10.7168 10.7168 11.9629 10.7168 13.5C10.7168 15.0372 11.9629 16.2832 13.5 16.2832Z",
    fill: "#1A73E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 9.98437H19.5882C18.9712 8.91545 18.0837 8.02779 17.0148 7.41065C15.946 6.79352 14.7336 6.46867 13.4994 6.46875C12.2652 6.46883 11.0528 6.79387 9.98404 7.41116C8.9153 8.02843 8.02792 8.91623 7.41113 9.98523L10.4553 15.2578C10.1464 14.7235 9.98444 14.1177 9.98424 13.5004C9.98404 12.8831 10.1464 12.2768 10.4549 11.7423C10.7634 11.2077 11.2073 10.7638 11.7418 10.4552C12.2763 10.1466 12.8827 9.98424 13.4999 9.98437Z",
    fill: "url(#paint2_linear_957_1273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_1273",
    x1: 14.2609,
    y1: 20.0914,
    x2: 8.17239,
    y2: 9.54578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_957_1273",
    x1: 12.4739,
    y1: 20.5486,
    x2: 18.5624,
    y2: 10.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_957_1273",
    x1: 7.41118,
    y1: 10.8635,
    x2: 19.5882,
    y2: 10.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.48a901f15f12b8bef646f28770cc5db2.svg";
export { ForwardRef as ReactComponent };